import Blank from "@/layouts/blank.vue";

import TripList from "@/pages/admin/trip/TripList.vue";
import TripDetails from "@/pages/admin/trip/TripDetails.vue";

import NewTripDetails from "@/pages/admin/trip/NewTripDetails.vue";
import TripSchedulingList from "@/pages/admin/trip/TripSchedulingList.vue";

const tripRoutes = [
  {
    path: "trip",
    name: "app-admin-trip",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/trip/list",
      },
      // {
      //   path: "list",
      //   name: "app-admin-trip-list",
      //   component: TripList,
      // },
      {
        path: "list",
        name: "app-admin-trip-list",
        component: TripSchedulingList,
      },
      {
        path: "details",
        name: "app-admin-trip-details",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/admin/trip/list",
          },
          // {
          //   path: ":id",
          //   name: "app-admin-trip-details-id",
          //   component: TripDetails,
          // }
          {
            path: ":id",
            name: "app-admin-trip-details-id",
            component: NewTripDetails,
          },
        ],
      },
    ],
  },
];

export default tripRoutes;
